import { getConditionsFilterConfig } from '../filters/condition';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getSizeFilterConfig } from '../filters/size';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { BuilderSections } from '../../util/builder';
import { getTagsFilterConfig } from '../filters/styles';
import { FilterId } from '../../types/filters/filters';

const mondettausaSizes = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  '2XL',
  '3XL',
  '1X',
  '2X',
  '3X',
  'One Size',
];

const mondettausaTags = [
  { key: 'mpgSport', label: 'MPG Sport', tags: ['MPG'] },
  { key: 'modernAmbition', label: 'Modern Ambition', tags: ['Modern Ambition', 'modern-ambition'] },
  { key: 'mondettaOriginals', label: 'Mondetta Originals', tags: ['Originals'] },
  { key: 'mondetta', label: 'Mondetta', tags: ['Mondetta'] },
];

export const mondettausaShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getBrandDirectFilterConfig(),
    getConditionsFilterConfig(),
    getTagsFilterConfig({
      id: FilterId.Style,
      options: mondettausaTags,
      shouldUseTreetOptions: true,
    }),
    getSizeFilterConfig({ sizes: mondettausaSizes }),
  ],
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: '92c0b2f71e7c45e4b958e520b0489e1b',
    },
  },
};
